import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import DOMPurify from "dompurify";
import API from "../lib/api";
import { ArrowLeft } from "lucide-react";

export default function StaticPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    API.get(`/pages/${slug}`).then(r => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <div className="min-h-screen bg-[#0B0E14] flex items-center justify-center">
      <div className="text-center"><p className="text-[#94A3B8]">Page not found</p><Link to="/" className="text-sm text-[#00F0FF] hover:underline mt-2 block">Go home</Link></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0B0E14] px-6 py-12" data-testid={`page-${slug}`}>
      <div className="max-w-3xl mx-auto">
        <Link to="/dashboard" className="text-sm text-[#00F0FF] hover:underline flex items-center gap-1 mb-6"><ArrowLeft className="w-3 h-3" /> Back</Link>
        <h1 className="text-3xl font-bold text-[#F8FAFC] mb-6">{page?.title || ""}</h1>
        {page?.content ? (
          <div className="prose prose-invert max-w-none text-[#94A3B8] leading-relaxed" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.content) }} />
        ) : (
          <p className="text-[#64748B]">This page has no content yet. Admin can add content from the Content Management panel.</p>
        )}
      </div>
    </div>
  );
}
